import { CSSObject } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.N200,
  borderBlockStart: `1px solid ${Color[theme].Surface.N300}`,
  display: 'flex',
  justifyContent: 'space-around',
  // adjust spacing to approximately match size of scrollbar tray
  paddingInlineEnd: Spacing.XS * 5,
})
